import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { logout } from "helpers/auth-functions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getBusinessess, getBusinessInfo } from "redux-context/business";
import { getDomainMetadata } from "redux-context/domain";
import { getLoggedUserInfo } from "redux-context/user";
import { getTokenBySessionId } from "services/SauceService";

const SigninSession: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");
  useEffect(() => {
    const fetchToken = async () => {
      if (sessionId) {
        try {
          const response: any = await getTokenBySessionId({ sessionId });
          localStorage.setItem("token", response.accessToken);
          localStorage.setItem("businessId", response.businessId);
          dispatch(getBusinessess());
          dispatch(getBusinessInfo());
          dispatch(getDomainMetadata());
          dispatch(getLoggedUserInfo());
          navigate("/welcome");
        } catch (error) {
          console.error("Error fetching token:", error);
          logout();
          navigate("/welcome");
        }
      } else {
        console.log("No Session ID");
        logout();
      }
      navigate("/welcome");
    };

    fetchToken();

    let timeout: NodeJS.Timeout;
    if (sessionId) {
      timeout = setTimeout(() => {
        navigate(".", { replace: true });
      }, 10000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [sessionId, dispatch, navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 48 }} />}
        tip="loading..."
      />
    </div>
  );
};

export default SigninSession;
